module.exports = __webpack_public_path__ + "assets/img/bg.ff60dd62.png";